import { ParserFunction } from '../type';

const APOSTROPHE_CHAR = "'";

const toPossessive = (text: string) => {
  if (!text) {
    return text;
  }

  const lastChar = text.slice(-1);
  const endOfWord = lastChar.toLowerCase() === 's' ? APOSTROPHE_CHAR : `${APOSTROPHE_CHAR}s`;

  return `${text}${endOfWord}`;
};

export const userLabelParser: ParserFunction = (name: string) => `${toPossessive(name)} Owner`;
